import { c as _c } from "react/compiler-runtime";
import { mergeProps } from "@base-ui/react/merge-props";
import { useRender } from "@base-ui/react/use-render";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";
import { Separator } from "@/components/ui/separator";
const buttonGroupVariants = cva("flex w-fit items-stretch *:focus-visible:relative *:focus-visible:z-10 has-[>[data-slot=button-group]]:gap-2 has-[select[aria-hidden=true]:last-child]:[&>[data-slot=select-trigger]:last-of-type]:rounded-r-lg [&>[data-slot=select-trigger]:not([class*='w-'])]:w-fit [&>input]:flex-1", {
  variants: {
    orientation: {
      horizontal: "*:data-slot:rounded-r-none [&>[data-slot]:not(:has(~[data-slot]))]:rounded-r-lg! [&>[data-slot]~[data-slot]]:rounded-l-none [&>[data-slot]~[data-slot]]:border-l-0",
      vertical: "flex-col *:data-slot:rounded-b-none [&>[data-slot]:not(:has(~[data-slot]))]:rounded-b-lg! [&>[data-slot]~[data-slot]]:rounded-t-none [&>[data-slot]~[data-slot]]:border-t-0"
    }
  },
  defaultVariants: {
    orientation: "horizontal"
  }
});
function ButtonGroup(t0) {
  const $ = _c(11);
  let className;
  let orientation;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      orientation,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = orientation;
    $[3] = props;
  } else {
    className = $[1];
    orientation = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className || $[5] !== orientation) {
    t1 = cn(buttonGroupVariants({
      orientation
    }), className);
    $[4] = className;
    $[5] = orientation;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== orientation || $[8] !== props || $[9] !== t1) {
    t2 = <div role="group" data-slot="button-group" data-orientation={orientation} className={t1} {...props} />;
    $[7] = orientation;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}
function ButtonGroupText(t0) {
  const $ = _c(10);
  let render;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    const {
      className,
      render: t4,
      ...props
    } = t0;
    render = t4;
    t3 = useRender;
    t1 = "div";
    t2 = mergeProps({
      className: cn("flex items-center gap-2 rounded-lg border bg-muted px-2.5 text-sm font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4", className)
    }, props);
    $[0] = t0;
    $[1] = render;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    render = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      slot: "button-group-text"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== render || $[7] !== t1 || $[8] !== t2) {
    t5 = {
      defaultTagName: t1,
      props: t2,
      render,
      state: t4
    };
    $[6] = render;
    $[7] = t1;
    $[8] = t2;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t3(t5);
}
function ButtonGroupSeparator(t0) {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      orientation: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const orientation = t1 === undefined ? "vertical" : t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("relative self-stretch bg-input data-horizontal:mx-px data-horizontal:w-auto data-vertical:my-px data-vertical:h-auto", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== orientation || $[7] !== props || $[8] !== t2) {
    t3 = <Separator data-slot="button-group-separator" orientation={orientation} className={t2} {...props} />;
    $[6] = orientation;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
export { ButtonGroup, ButtonGroupSeparator, ButtonGroupText, buttonGroupVariants };